import React from "react";
import ReactModal from "react-modal";
import * as R from "ramda";
import LocationFormFields from "./LocationFormFields";
import { connect } from "react-redux";
import { updateOne } from "actions/location";
import Icon from "components/Icon";

const mapStateToProps = state => ({
  isUpdating: state.location.isUpdating
});

const mapDispatchToProps = { updateOne };

class UpdateLocationModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      location: { ...props.location }
    };
  }

  handleSubmit = event => {
    event.preventDefault();
    const { updateOne } = this.props;
    const { location } = this.state;
    updateOne(location.id, location).then(this.handleCloseModal);
  };

  handleChange = (fields, value) => {
    this.setState(R.assocPath(fields, value));
  };

  handleOpenModal = () => {
    this.setState({ showModal: true });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  handleDelete = () => {
    this.props.onDelete(this.props.id).then(this.handleCloseModal);
  };

  render() {
    const { title } = this.props;
    return (
      <div>
        <button
          type="button"
          className="btn btn-primary"
          onClick={this.handleOpenModal}
        >
          <Icon icon="pencil-alt" />
        </button>
        <ReactModal
          onRequestClose={this.handleCloseModal}
          className="Modal"
          overlayClassName="Overlay"
          isOpen={this.state.showModal}
          contentLabel="Delete Confirmation"
        >
          <form onSubmit={this.handleSubmit}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{title}</h5>
                </div>
                <div className="modal-body">
                  <LocationFormFields
                    location={this.state.location}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="modal-footer">
                  <button className="btn btn-primary" type="submit">
                    Rediger
                  </button>
                  <button className="btn" onClick={this.handleCloseModal}>
                    Avbryt
                  </button>
                </div>
              </div>
            </div>
          </form>
        </ReactModal>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  UpdateLocationModal
);



// WEBPACK FOOTER //
// ./src/components/UpdateLocationModal.js